import { Component, ContentChild, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { BaseController, IColumnSetting } from '@discoverer/core/services';
import { AppSettingsService, ITab2, TabSettingsService } from '@discoverer/core/services/dynamic-reports-services';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { debounceTime, filter, map, distinctUntilChanged, delay, shareReplay, take, skip, switchMap } from 'rxjs/operators';

export class CustomTabContext {
    constructor(
        public currentTab: ITab2,
        public columnSettings: IColumnSetting[],
    ) { }
}

export interface TabConfig {
    appId: string;
    tabId: string;
}

@Component({
    selector: 'disco-tab-provider',
    templateUrl: './disco-tab-context-provider.html',
    styleUrls: ['./disco-tab-context-provider.scss'],
    providers: [TabSettingsService]
})
export class DiscoTabContextProviderComponent extends BaseController implements OnInit, OnDestroy {
    private _config: TabConfig;
    private _initialized = false;

    @Input() emitOnChanges = false;

    @Input()
    set config(val: TabConfig) {
        if (this._config?.appId !== val?.appId || this._config?.tabId !== val?.tabId) {
            this._initialized = false;
        }
        this._config = val;
        this.initializeIfReady();
    }

   
    @Output()
    context = new EventEmitter<CustomTabContext>(true);

    @ContentChild(TemplateRef) template: TemplateRef<any>;


    private _contextSubscription: Subscription | null = null;

    constructor(
        private _appSettings: AppSettingsService,
        private _tabSettings: TabSettingsService
    ) {
        super();
    }

    public ngOnInit() {
        this.initializeIfReady();
    }

    public ngOnChanges(changes) {
        if (changes['config']) {
            return;
        }
    }

    private async initializeIfReady() {
        if ((!this._config?.appId || !this._config?.tabId || this._initialized) && !this.emitOnChanges) {
            return;
        }

        this._initialized = true;

        try {
            if (this._contextSubscription) {
                this._contextSubscription.unsubscribe();
                this._contextSubscription = null;
            }

            console.log(`Provider initializing for app: ${this._config.appId}, tab: ${this._config.tabId}`);
            await this._tabSettings.setCurrentTab(this._config.tabId, this._config.appId);
            const tab = await this._tabSettings.getCurrentTab();
            const columns = await this._tabSettings.updateTabColumns(tab.key);
            console.log(`Provider fetched - Tab: ${tab?.key}, Columns: ${columns?.length}, Expected: ${this._config.tabId}`);
            
            if (tab?.app?.key === this._config.appId && tab?.key === this._config.tabId && columns && columns.length > 0) {
                this.context.emit(null);
                this.context.emit(new CustomTabContext(tab, columns));
            } else {
                console.warn(`Tab/column mismatch after setCurrentTab. Expected: ${this._config.appId}::${this._config.tabId}, Got: ${tab?.app?.key}::${tab?.key}`);
            }
        } catch (error) {
            console.error(`Failed to initialize disco-tab for app ${this._config.appId}, tab ${this._config.tabId}:`, error);
        }
    }
}

